import {
  ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
} from '@angular/core';
import { NgModel } from '@angular/forms';
import { IconComponent } from '@rivet-health/design-system';
import { ModalCloseMethod } from '@rivethealth/data/analytics/account-analytics-events';
import { isArray } from 'lodash';
import { ChangeService } from '../core/change.service';
import { Loadable } from '../helpers/loadable';

@Component({
  selector: 'modal-info',
  styleUrls: ['./modal-info.component.scss'],
  templateUrl: './modal-info.component.html',
  providers: [ChangeService],
})
export class ModalInfoComponent implements OnInit {
  @Input() compact: boolean = false;

  @Input() allowOverflow: boolean = false;

  @Input() leftLink: boolean = true;

  @Input() iconName?: IconComponent.Name = 'Edit';
  @Input() leftLinkText: string = 'Edit payer info';

  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private readonly changeService: ChangeService,
  ) {}

  @Input() focus: HTMLInputElement;

  @Input() outerWidth: string;
  @Input() width: string;

  @ContentChildren(NgModel, { descendants: true })
  controls: QueryList<NgModel>;

  @Input() load: Loadable<any> | Loadable<any>[];
  @Input() loading = false;
  @Input() erred = false;

  @Input() backgroundShading = true;

  get anyLoading(): boolean {
    if (!this.load) {
      return this.loading;
    }
    if (isArray(this.load)) {
      return this.load.some(({ loading }) => loading);
    } else {
      return this.load.loading;
    }
  }

  @Input() title: string;

  @Input() overrideFooter = false;

  @Output() close = new EventEmitter();
  @Output() innerModalAction = new EventEmitter();

  ngOnInit() {
    if (this.focus) {
      this.focus.focus();
    }
  }

  closeMethodRef: { method: ModalCloseMethod } | undefined = undefined;
  setCloseMethod(method: ModalCloseMethod) {
    if (this.closeMethodRef) {
      this.closeMethodRef.method = method;
    }
  }
}
